"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { DropdownUI } from '../../DropdownUI/index.mjs';
import { forwardRef } from 'react';
import { useComboBoxDropdownContext } from '../context/use-combobox-dropdown.mjs';
import { useNavigationContext } from './KeyboardNavigation/use-navigation.mjs';

const DrillUpButton = forwardRef(
  ({ onClick, ...props }, ref) => {
    const { drillUp, drillDownStackTop } = useComboBoxDropdownContext();
    const { currentItem } = useNavigationContext();
    if (!drillDownStackTop) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      DropdownUI.BackButton,
      {
        ref,
        onClick: (e) => {
          drillUp();
          onClick?.(e);
        },
        "data-current": currentItem === "drill-up" ? true : void 0,
        ...props,
        children: drillDownStackTop.label
      }
    );
  }
);

export { DrillUpButton };
